<div class="main-container">
  <div class="document-container" *ngIf="documents?.length>0">
   
    <div style="margin-bottom: 10px;display: flex;justify-content: space-between;align-items: center;">
      <h3 *ngIf="!documentLink" style="color: var(--lead-info-color, #0a7ea4);">Lead documents</h3>
      <div>
        <button mat-flat-button color="primary" [matMenuTriggerFor]="menu">
          Document link <mat-icon>insert_link</mat-icon>
        </button>
        
        
        <mat-menu #menu="matMenu">
          <button class="custom-menu-item" [disabled]="documentLink" mat-menu-item (click)="generate('link','documents')">Get link<mat-icon>insert_link</mat-icon></button>
          <button class="custom-menu-item" [disabled]="invalid_sms" mat-menu-item (click)="generate('sms','documents')" [style.color]="invalid_sms ? 'red' : ''">Send link via sms<mat-icon [style.color]="invalid_sms ? 'red' : ''">{{invalid_sms ? 'phonelink_erase':'smartphone'}}</mat-icon></button>
          <button class="custom-menu-item" [disabled]="invalid_email" mat-menu-item (click)="generate('email','documents')" [style.color]="invalid_email ? 'red' : ''">Send link via email<mat-icon [style.color]="invalid_email ? 'red' : ''">{{invalid_sms ? 'mail_lock':'email'}}</mat-icon></button>
        </mat-menu>
      </div>
      <span class="link" *ngIf="documentLink">
        <a style="cursor: pointer; text-decoration: underline;color: var(--lead-text-primary, #000000);"
           (click)="openLink(documentLink)"
           [matTooltip]="documentLink"
           [title]="documentLink">
          {{ documentLink | truncate:50 }}
        </a>

        <mat-icon
          (click)="copyText(documentLink)"
          style="cursor: pointer;color: var(--lead-text-secondary, #888);">
          content_copy
        </mat-icon>
      </span>
    </div>
  <!-- Updated document item in document-container -->
  <div *ngFor="let document of documents" class="document-item">
    <div class="document-content">
      <!-- Left Side -->
      <div class="left-side">
        <div class="document-header">
          <h3 class="document-name">
            {{ document.document.name }}
            <span class="document-type">({{document.document.type}})</span>
            <!-- Staff Upload Badge -->
            <span *ngIf="!document.document.allowStudentsUpload" class="staff-upload-badge">
              Reps Upload Required
            </span>
          </h3>
        </div>
        <p class="description" [innerHTML]="document.document.uploadDescription"></p>
        <div class="document-footer">
          <span *ngIf="document.status !== documnetStatus.DRAFT" class="time-uploaded">
            Uploaded: {{ document.uploaded_at | date:'medium' }}
          </span>
        </div>
      </div>
      
      <!-- Middle - Image with Approval/Disapproval Icons -->
      <div class="middle-side">
        <div *ngIf="document.status === documnetStatus.SUBMITTED" class="approval-icons">
          <span class="approve-icon" matTooltip="Approve document" matTooltipPosition="above" (click)="approveDocument(document,false)">✔️</span>
          <span class="reject-icon" matTooltip="Reject document" matTooltipPosition="above" (click)="rejectDocument(document,false)">❌</span>
        </div>
        <div *ngIf="document.status === documnetStatus.APPROVED || document.status === documnetStatus.REJECTED">
          <span class="approve-icon" *ngIf="document.status !== documnetStatus.APPROVED" matTooltip="Switch to approve" matTooltipPosition="above" (click)="reApproveDocument(document)">✔️</span>
          <span class="reject-icon" *ngIf="document.status !== documnetStatus.REJECTED" matTooltip="Switch to reject" matTooltipPosition="above" (click)="reRejectDocument(document)">❌</span>
        </div>
        <div class="document-photo" *ngIf="document.cloud_key">
          <div class="image-section">
            <app-image-section [doc]="document"></app-image-section>
          </div>
        </div>
  
        <!-- File Upload for DRAFT or REJECTED status -->
        <div *ngIf="document.status === documnetStatus.DRAFT || document.status === documnetStatus.REJECTED" class="file-upload">
          <label for="file-upload-{{document.id}}" class="file-upload-label">
            <mat-icon style="cursor: pointer;">attach_file</mat-icon>
          </label>
          <input id="file-upload-{{document.id}}" type="file" (change)="onFileSelected($event, document)" accept=".xls,.xlsx,.pdf,.doc,.docx,image/*" style="display: none;" />
        </div>
      </div>
  
      <!-- Right Side - Status -->
      <div class="right-side">
        <span class="status" 
          [ngClass]="{
            'uploaded': document.status === documnetStatus.SUBMITTED,
            'draft': document.status === documnetStatus.DRAFT,
            'not-submited': document.status === documnetStatus.NOT_SUBMITTED,
            'approved': document.status === documnetStatus.APPROVED,
            'rejected': document.status === documnetStatus.REJECTED,
          }">
          {{ document.status }}
        </span>
      </div>
    </div>
  </div>
  </div>
  
  <div class="applications-container" *ngIf="lead_applications?.length > 0 || missingApplications?.length>0">
    <div *ngFor="let application of lead_applications" class="application-item">
      <div class="application-content">
        <!-- Left Side -->
        <div class="left-side">
          <h3>{{getDisplayName(application?.application?.type)}}</h3>
          <p class="description">Application for {{getDisplayName(application?.application?.type)}}</p>          <!-- Application Date -->
          <div class="application-date" *ngIf="getApplicationDate(application.application.type)">
            <span class="date-label">Submitted:</span>
            <span class="date-value">{{ getApplicationDate(application.application.type) | date:'medium' }}</span>
          </div>
        </div>
  
        <!-- Right Side - View button and menu -->
        <div class="right-side">
          <span class="status application-status" (click)="viewApplication(application)">View {{getDisplayName(application?.application?.type)}}</span>
          
          <!-- Three dots menu -->
          <button mat-icon-button [matMenuTriggerFor]="appMenu">
            <mat-icon>more_vert</mat-icon>
          </button>
          
          <mat-menu #appMenu="matMenu">
            <button mat-menu-item (click)="exportApplication(application)">
              <mat-icon>download</mat-icon>
              <span>Export</span>
            </button>
            <button mat-menu-item (click)="clearApplication(application)">
              <mat-icon>delete</mat-icon>
              <span>Remove</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
  
    <div *ngFor="let application of missingApplications" class="application-item">
      <div class="application-content">
        <!-- Left Side -->
        <div class="left-side">
          <div style="font-size: 18px;">{{ getDisplayName(application) }}</div>
          <p class="description"></p>
        </div>
  
        <!-- <span class="status generate-link" (click)="generateLink(application)">Generate link</span> -->
        <button mat-flat-button color="primary" [matMenuTriggerFor]="menu">
          Generate link <mat-icon>insert_link</mat-icon>
        </button>
        
        
        <mat-menu #menu="matMenu">
          <button class="custom-menu-item" [disabled]="(application === 'lead_application' && linkApplication) || (application === 'financial_aid' && linkFinancialAid)" mat-menu-item (click)="generate('link',application)">Get link<mat-icon>insert_link</mat-icon></button>
          <button class="custom-menu-item" [disabled]="invalid_sms" mat-menu-item (click)="generate('sms',application)" [style.color]="invalid_sms ? 'red' : ''">Send link via sms<mat-icon [style.color]="invalid_sms ? 'red' : ''">{{invalid_sms ? 'phonelink_erase':'smartphone'}}</mat-icon></button>
          <button class="custom-menu-item" [disabled]="invalid_email" mat-menu-item (click)="generate('email',application)" [style.color]="invalid_email ? 'red' : ''">Send link via email<mat-icon [style.color]="invalid_email ? 'red' : ''">{{invalid_email ? 'mail_lock':'email'}}</mat-icon></button>
        </mat-menu>
      </div>
  
      <span class="link" *ngIf="(application === 'lead_application' && linkApplication) || (application === 'financial_aid' && linkFinancialAid)">
        <a style="cursor: pointer; text-decoration: underline;color: var(--lead-text-primary, #000000);"
          (click)="openLink(application === 'lead_application' ? linkApplication : linkFinancialAid)"
           [matTooltip]="application === 'lead_application' ? linkApplication : linkFinancialAid"
           title="{{ application === 'lead_application' ? linkApplication : linkFinancialAid }}">
          {{ (application === 'lead_application' ? linkApplication : linkFinancialAid) | truncate:50 }}
        </a>

        <mat-icon
          (click)="copyText(application === 'lead_application' ? linkApplication : linkFinancialAid)"
          style="cursor: pointer;color: var(--lead-text-secondary, #888);">
          content_copy
        </mat-icon>
      </span>
  
    </div>
    <hr>
  </div>